var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('hero-carousel',{attrs:{"commonData":_vm.commonData}}),_c('Products',{attrs:{"data":_vm.productsData}}),_c('Solutions',{attrs:{"data":_vm.solutionsData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }